module.exports = __webpack_public_path__ + "static/media/arrow_s_down.3f8fcb77.svg";